import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1.5 flex-wrap text-sm text-foreground-600" aria-label="面包屑导航">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={`${item.label}-${index}`}>
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />}
            {item.to && !isLast ? (
              <Link to={item.to} className="whitespace-nowrap hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-900 font-medium" aria-current={isLast ? 'page' : undefined}>
                {item.label}
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}